import { Component, EventEmitter, Inject, Output } from "@angular/core";
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { VerbatimDetailsModal } from "../../category-builder/category-builder.models";

@Component({
  selector: "app-verbatim-modal",
  templateUrl: "./verbatim-modal.component.html",
  styleUrls: ["./verbatim-modal.component.scss"],
  standalone: false,
})
export class VerbatimModalComponent {
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: VerbatimDetailsModal,
  ) {}
}
